import {DataFrameColumnDef, DataFrameColumns} from 'data-frames/DataFrameTypes';

import isSystemColumn from './isSystemColumn';

export default function getUserColumns({columns}: {columns: DataFrameColumns}): Array<DataFrameColumnDef> {
  return columns.filter((column) => !isSystemColumn(column));
}
